import { PageSettings } from 'Shared/model/venueSettings';


export const slugPattern = /^[a-z0-9]+(-[a-z0-9]+)*$/;

/*
	The frontend paths a page can't take. A page is served by the '*' route in VenueRoutes, and
	solid-router's scoreRoute() puts a wildcard below every static route, so a page whose slug is one
	of these would simply never be reached.

	A menu's slug is not reserved. Menus are served off the same wildcard (see CustomPage), and a page
	of the same name simply wins - so the four paths that used to be routes bolted on to a single
	venue's settings class ('/food' and '/drinks' for Darling Nikki's, '/drink' and '/dine' for The
	Drummer) are ordinary menu slugs now and are gone from this list.

	Spelt lower case, which is how the router compares a static segment: '/staffresources' reaches
	the '/staffResources' route, so the slug is taken whichever way it is typed.
*/
export const reservedSlugs = [
	'menu','event','staffresources','staffresource',
	'login','admin','forgotpassword','resetpassword','setpasswordatregistration','redirected',
];


/* The reason the slug can't be used, or undefined if it can. 'exceptSlug' is the page being
   renamed, which doesn't count as taking its own slug. */
export function slugError(slug:string, pages:PageSettings[], exceptSlug:string|undefined): string|undefined
{
	if (slug == '')
		return 'A slug is needed';

	if (!slugPattern.test(slug))
		return 'A slug is lower case letters, digits and hyphens - eg whats-on';

	if (reservedSlugs.includes(slug))
		return `'${slug}' is used by the site itself`;

	if (pages.some(page => page.slug==slug && page.slug!=exceptSlug))
		return `'${slug}' is already taken by another page`;

	return undefined;
}


/* What the page name a venue types becomes before they edit it. */
export function slugify(title:string)
{
	return title.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
}


export function frontendRoute(page:PageSettings)
{
	return page.home ? '/' : '/'+page.slug;
}


export function backendRoute(slug:string)
{
	return '/admin/page/'+slug;
}
